// extracted by mini-css-extract-plugin
export var active = "_ed-7";
export var container = "_ed-0";
export var evenWidth = "_ed-4";
export var large = "_ed-5";
export var outlet = "_ed-8";
export var slide = "_ed-2";
export var small = "_ed-6";
export var tab = "_ed-3";
export var tabs = "_ed-1";